export class UpdateWorkspaceStorageAccessConfigurationInputAws {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "allowedPrincipals",
            "baseName": "allowedPrincipals",
            "type": "Array<WorkspaceAllowedPrincipalInput>",
            "format": ""
        },
        {
            "name": "requirePrincipalTags",
            "baseName": "requirePrincipalTags",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateWorkspaceStorageAccessConfigurationInputAws.attributeTypeMap;
    }
    constructor() {
    }
}
